import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import useAppStore from "./stores/useAppStore";
import { FontLoader, GlobalStyles } from "./styles/GlobalStyles";
import { AuthProvider } from "./contexts/AuthContext";
import App from "./App";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  sendDefaultPii: false,
});

function Root() {
  const theme = useAppStore((s) => s.theme);
  return (
    <>
      <FontLoader />
      <GlobalStyles theme={theme} />
      <AuthProvider>
        <App />
      </AuthProvider>
    </>
  );
}

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((reg) => {
      // Force check for SW updates on every page load
      reg.update().catch(() => {});
    }).catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Sentry.ErrorBoundary
      fallback={<div style={{ padding: 24, fontFamily: "system-ui" }}>Une erreur s’est glissée. Recharge la page.</div>}
      showDialog={false}
    >
      <Root />
    </Sentry.ErrorBoundary>
  </BrowserRouter>
);
